/**
 * Includes the primary menu list entries shown on the very left side.
 * Primary list entries are shown in the menu section above the separator.
 */

import React, {useContext} from 'react';
import {List} from '@mui/material'
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SchoolIcon from '@mui/icons-material/School';
import {NavLink} from 'react-router-dom'
import {useStyles} from "./GameNavItems.css";
import {FirebaseAuthContext} from "../../../commons/firebase/FirebaseAuthProvider";
import BasicHint from "../../../commons/utils/hint/BasicHint";
import {useIntl} from "react-intl";


const GameNavItemsPrimary = () => {
    const classes = useStyles()
    const {signedInUserRoleScopes} = useContext(FirebaseAuthContext);

    // Internationalization for simple strings
    const intl = useIntl();

    const profileDataIncomplete = signedInUserRoleScopes?.length === 0

    return (
        <List>
            <ListItem button component={NavLink} exact activeClassName={classes.active} className={classes.inactive}
                      disabled={profileDataIncomplete}
                      to={"/game/dashboard"}>
                <ListItemIcon>
                    <DashboardIcon/>
                </ListItemIcon>
                Dashboard
            </ListItem>

            <ListItem button component={NavLink} exact activeClassName={classes.active} className={classes.inactive}
                      disabled={profileDataIncomplete}
                      to={"/game/courses"}>
                <ListItemIcon>
                    <SchoolIcon activeClassName={classes.active}/>
                </ListItemIcon>
                Courses
            </ListItem>

            <BasicHint options={{visible: profileDataIncomplete, placement: 'auto'}}
                       hintText={intl.formatMessage({
                           id: 'app.navigation.profile.hint',
                           defaultMessage: 'Complete profile to start!'
                       })}
                       element={
                           <ListItem button component={NavLink} activeClassName={classes.active}
                                     className={classes.inactive}
                                     to={"/common/profile"}>
                               <ListItemIcon>
                                   <AccountCircleIcon/>
                               </ListItemIcon>
                               Profile
                           </ListItem>
                       }/>


        </List>
    )
}

export default GameNavItemsPrimary